/**
 * toont een popup met de content (children)
 * title = optionele titel
 * has_close_btn = wel/niet sluitknop
 * callback = functie bij de close_btn
 *
 */
import React from "react";


export class Popup extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={"tool__popup__wrapper"}>
                <div className={"tool__popup__header"}>
                    <h2>{this.props.title}</h2>
                {this.props.has_close_btn && (
                    <a href="javascript:void(0);" onClick={this.props.callback}><img src={"/digibord/assets/svgs/popup_close_btn.svg"} className="tool__popup__close_btn" alt="Terug" /></a>
                )}
                </div>
                <div className={"tool__popup__content"}>

                    {this.props.children}
                </div>
            </div>
        )
    }
}
